
const CONFIG = 
{
  API_URL: 'https://web-production-1f849.up.railway.app',
    localHost: "http://127.0.0.1:5000"
};

export default CONFIG;
